import {
    GET_PLAYERS_SUCCESS,
    CLEAR_PLAYERS,
    SET_QUIZ_FILTER_PLAYER_SUCCESS,
    DELETE_QUIZ_USER_PLAYER_SECCESS,
    PSEUDONONYMIZE_PLAYER_SECCESS,
    DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE_SUCCESS,
    DELETE_QUIZ_ALL_USER_PLAYERS_SUCCESS
} from './constants';


const initialPlayersState = [];
/**
 *
 * @param state
 * @param action
 * @returns {{}|Array|*|playersReducer}
 */
const playersReducer = (state = initialPlayersState, action) => {
    switch (action.type) {
        case CLEAR_PLAYERS:{
            return {};
        }
        case GET_PLAYERS_SUCCESS:{
            return { ...action.players };
        }
        case SET_QUIZ_FILTER_PLAYER_SUCCESS:{
            return  {...action.players };
        }
        case DELETE_QUIZ_USER_PLAYER_SECCESS: 
            return action.players;
        case PSEUDONONYMIZE_PLAYER_SECCESS: 
            return action.players;
        case DELETE_QUIZ_ALL_USER_PLAYERS_SUCCESS:
            return action.players.current_data;
        default:
            return state;
    }
};

const initialFileState = { url: null};
/**
 *
 * @param state
 * @param action
 * @returns {({url}&{url: (*|string)})|{url: null}}
 */
const excelQuizFileReducer = (state = initialFileState, action) => {
    switch (action.type) {
        case DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE_SUCCESS: {
            return {...state, url: action.file.url || ''};
        }
        default:
            return state;
    }
};

export{ playersReducer as players,excelQuizFileReducer as excelQuizFile };